/* 
所有路由配置的数组
*/
export default [
  {
    path: "/",
    component: () => import("@/pages/Home"),
  },
  {
    path: '/Home',
    component: () => import('@/pages/Home'),
  },
  {
    path: '/entry',
    component: () => import('@/pages/entry'),
  },
  {
    path: '/My',
    component: () => import('@/pages/My'),
  },
  {
    path: '/festival',
    component: () => import('@/pages/festival'),
  },
  {
    path: '/add',
    component: () => import('@/pages/add'),
  },
  {
    path: '/rule',
    component: () => import('@/pages/rule'),
  }, {
    path: '/form',
    component: () => import('@/pages/form'),
  },
  {
    path: '/formChange',
    component: () => import('@/pages/formChange'),
  },
  {
    path: '/formFestival',
    component: () => import('@/pages/formFestival'),
  },
  {
    path: '/formChangeFestival',
    component: () => import('@/pages/formChangeFestival'),
  },
];
